import type { useTranslation } from "react-i18next";

import type { PersonaOpportunitySetType } from "../../../types/persona-opportunities.types.js";

type Translate = ReturnType<typeof useTranslation>["t"];

export function hubSetTypeLabel(t: Translate, type: PersonaOpportunitySetType): string {
  if (type === "COMPETITOR") {
    return t("personaOpportunities.hub.sets.typeCompetitor", "Competitor driven");
  }
  if (type === "USER_GENERATED") {
    return t("personaOpportunities.hub.sets.typeCustom", "Custom");
  }
  if (type === "POST_FLIGHT") {
    return t("personaOpportunities.hub.sets.typePostFlight", "Post-Flight");
  }
  return t("personaOpportunities.hub.sets.typePersona", "Personas driven");
}
